import { Injectable } from '@angular/core';
import { ModifierDto } from '@symphony-solo/domain/modifiers/src';
import { PriceLevelDto } from '@symphony-solo/domain/price-levels/src';
import { roundTwoDecimals } from '@symphony-solo/shared/utils/src';
import { TransactionLineProductBuilder } from '../builders';
import { TransactionLineProductDto } from '../dtos';
import { TransactionProduct } from '../models';

@Injectable()
export class TransactionLineProductGeneratorService {
  public createTransactionLineProduct(
    product: TransactionProduct,
    modifiersDictionary: { [key: number]: ModifierDto },
    priceLevelsDictionary: { [key: number]: PriceLevelDto }
  ): TransactionLineProductDto {
    // essential data
    const modifier = this.getModifierByProductPriceModifier(product.price.modifier, modifiersDictionary);
    const priceLevel = this.getPriceLevelByProductPriceLevel(product.price.priceLevel, priceLevelsDictionary);

    // prices
    const unitPrice = product.price.value;
    const quantity = product.quantity;
    const taxAmount = product.taxAmount;
    const grossPrice = unitPrice * quantity;
    const netPrice = roundTwoDecimals(grossPrice - taxAmount);

    const transactionLineProduct = new TransactionLineProductBuilder()
      .setLineIsCorrected(product.lineIsCorrected)
      .addTransactionProduct(product.id, product.name)
      .setTaxRate(product.taxRate.id)
      .setQuantity(quantity)
      .setNetPrice(netPrice)
      .setTaxAmount(product.taxAmount)
      .setGrossPrice(grossPrice)
      .setUnitPrice(modifier, priceLevel, product.price)
      .build();
    return transactionLineProduct;
  }

  private getModifierByProductPriceModifier(modifierId: number, modifiersDictionary: { [key: number]: ModifierDto }): ModifierDto {
    const modifier = modifiersDictionary[modifierId];

    return modifier ? modifier : null;
  }

  private getPriceLevelByProductPriceLevel(priceLevelId: number, priceLevelsDictionary: { [key: number]: PriceLevelDto }): PriceLevelDto {
    const priceLevel = priceLevelsDictionary[priceLevelId];

    return priceLevel ? priceLevel : null;
  }
}
